export default "__VITE_ASSET__CMY4dK7C__"